import React, { Component } from "react";
import CarouselBox from "../Components/CarouselBox";
import { Card, Container, CardDeck } from "react-bootstrap";
import tile6 from "../assets/6.png";
import tile7 from "../assets/7.jpg";
import tile8 from "../assets/8.png";
import tile9 from "../assets/9.jpg";
import tile10 from "../assets/10.png";
import tile11 from "../assets/11.jpg";
import tile12 from "../assets/12.png";
import tile13 from "../assets/13.jpg";
import tile14 from "../assets/14.png";
import tile15 from "../assets/15.jpg";
import tile16 from "../assets/16.png";
import tile17 from "../assets/17.jpg";

export default class Home extends Component {
  render() {
    return (
      <>
        <CarouselBox />
        <Container>
          <h2 className="text-center m-4">Тротуарная плитка</h2>
          <CardDeck className="m-4">
            <Card className="bg-secondary text-white" border="primary">
              <Card.Img variant="top" src={tile6} />
              <Card.Body>
                <Card.Title>Блоки</Card.Title>
                <Card.Text>
                  ⁠Блоки для столбов. Размер  -  30х30 см. Высота - 20 см.По
                  цене 8  рублей
                </Card.Text>
              </Card.Body>
            </Card>

            <Card className="bg-secondary text-white" border="dark">
              <Card.Img variant="top" src={tile7} />
              <Card.Body>
                <Card.Title>Ковер</Card.Title>
                <Card.Text>
                  ⁠Тротуарная  плитка (ковер)– универсальный материал, который
                  нашел свое применение в отделке загородных домов, офисных и
                  жилых зданий, ландшафтном дизайне. Сегодня плитка тротуарная
                  выгодно отличается от ближайших конкурентов – брусчатки и
                  асфальтовых покрытий. Тротуарная плитка, цена которой
                  значительно ниже натурального камня, не уступает ему по
                  внешнему виду, более гармонично, чем асфальт вписывается в
                  дизайн приусадебного участка или архитектуру городской улицы.
                  В то же время, тротуарная плитка, укладка которой не
                  является дорогостоящим видом услуг - это прочный и долговечный
                  материал.В 1 кв метре 4 штуки по цене 16 рублей
                </Card.Text>
              </Card.Body>
            </Card>

            <Card className="bg-secondary text-white" border="dark">
              <Card.Img variant="top" src={tile8} />
              <Card.Body>
                <Card.Title>Вставка клевер краковский</Card.Title>
                <Card.Text>
                  ⁠⁠Тротуарная плитка "Вставка клевер краковский" представляет
                  собой сочетание бетонных изделий размером 295х295х45мм., для
                  ложения дорожек, тротуаров, улиц, площадок. Изделие можно
                  использовать для устройства полов гаражей, подвальных
                  помещений, для благоустройства могил, прекрасно подходит в
                  качестве укладки проходных дорожек, преддомного пространства.В
                  1 кв метре 11 углов и три серединки по цене 18 рублей
                </Card.Text>
              </Card.Body>
            </Card>
          </CardDeck>

          <CardDeck className="m-4">
            <Card className="bg-secondary text-white" border="dark">
              <Card.Img variant="top" src={tile9} />
              <Card.Body>
                <Card.Title>Черепашка</Card.Title>
                <Card.Text>
                  ⁠Плитка с милым названием "Черепашка" имитирует натуральный
                  песчаник, благодаря хаотичным линиям поверхности и кварцевой
                  посыпке. Черепашка - квадратная, с противоскользящим
                  покрытием. Хорошо подходит для проходных зон, лестниц - везде,
                  где существует опасность обледенения и скольжения. Несмотря на
                  то, что поверхности покрыта рисунком, она не нуждается в
                  подгонке: вся прелесть - именно в хаотичных линиях. Каждый раз
                  при монтаже получается уникальный узор. Тротуарная плитка
                  "Черепашка" размер 300х300х30 идеально подходит для крыльца,
                  эксплуатируемых кровель, а как интересно она смотрится на
                  садовых дорожках.В 1 кв метре 11 штук по цене 12 рублей
                </Card.Text>
              </Card.Body>
            </Card>

            <Card className="bg-secondary text-white" border="dark">
              <Card.Img variant="top" src={tile10} />
              <Card.Body>
                <Card.Title>Цветочек</Card.Title>
                <Card.Text>
                  ⁠Краковский квадрат (Цветок) - идеальное решение для
                  оформления приусадебной территории. Одна из популярных форм,
                  сочетающая в себе сдержанный рельеф и красоту высокого вкуса.В
                  1 кв метре 11 штук по цене 12 рублей
                </Card.Text>
              </Card.Body>
            </Card>

            <Card className="bg-secondary text-white" border="dark">
              <Card.Img variant="top" src={tile11} />
              <Card.Body>
                <Card.Title>Клевер краковский (Ромашка)</Card.Title>
                <Card.Text>
                  ⁠Такая фигурная плитка, дополнит приятную атмосферу на вашем
                  загородном участке. В 1 м.кв. 12 больших плиток и 12
                  маленьких.  Интересный и редкий рисунок тротуарной плитки.
                  Такую плитку вы маловероятно увидите у соседа, а разные
                  варианты комбинаций цветов помогут создать неповторимый вид
                  тротуара. Рисунок клевера - плитка на удачу, ну или на дачу.
                  Так же во избежание лишней подрезки по контурам площадки,
                  можно отдельно приобрести половинки малых плиток. Поверхность
                  плитки гладкая с цветочными рисунками. Отлично смотрится на
                  больших площадках. Укладка под автотранспорт не желательна,
                  только в случае грамотной подготовки основания под плитку.
                </Card.Text>
              </Card.Body>
            </Card>
          </CardDeck>

          <CardDeck className="m-4">
            <Card className="bg-secondary text-white" border="dark">
              <Card.Img variant="top" src={tile12} />
              <Card.Body>
                <Card.Title>Дуб-Клён</Card.Title>
                <Card.Text>
                  ⁠Тротуарная плитка «Дуб-Клён» — это одна из самых популярных
                  форм фигурной тротуарной плитки. Она применяется для укладки
                  площадей, тротуаров, небольших дорожек и обладает отличными
                  дренажными свойствами.В 1 кв метре 11 штук по цене 12 рублей
                </Card.Text>
              </Card.Body>
            </Card>

            <Card className="bg-secondary text-white" border="dark">
              <Card.Img variant="top" src={tile13} />
              <Card.Body>
                <Card.Title>Калифорния</Card.Title>
                <Card.Text>
                  ⁠ Плитка тротуарная 30х30х3 см. "Калифорния". Рисунок из
                  четырех шершавых кирпичиков и гладкого квадрата в
                  центре. Применяется в укладке для всех пешеходных зон, нет
                  необходимости подбирать тротуарную плитку по рисунку.В 1 кв
                  метре 11 штук по цене 12 рублей
                </Card.Text>
              </Card.Body>
            </Card>

            <Card className="bg-secondary text-white" border="dark">
              <Card.Img variant="top" src={tile14} />
              <Card.Body>
                <Card.Title>Бордюр</Card.Title>
                <Card.Text>
                  ⁠Бордюр используется для окантовки и разграничения насаждений,
                  клумб, цветников, а также в парковом строительстве для
                  обустройства пешеходных зон ― парковых аллей, детских площадок
                  и других пешеходных участков. Стоимость одного бардюра 5
                  рублей
                </Card.Text>
              </Card.Body>
            </Card>
          </CardDeck>

          <CardDeck className="m-4">
            <Card className="bg-secondary text-white" border="dark">
              <Card.Img variant="top" src={tile15} />
              <Card.Body>
                <Card.Title>Ежик</Card.Title>
                <Card.Text>
                  ⁠Садовые фигуры, как декор сада.Садовая фигура ежик отлично
                  доплнят любую местность.Стоимость одного ёжика 10 рублей
                </Card.Text>
              </Card.Body>
            </Card>

            <Card className="bg-secondary text-white" border="dark">
              <Card.Img variant="top" src={tile16} />
              <Card.Body>
                <Card.Title>Шашечка</Card.Title>
                <Card.Text>
                  ⁠Тротуарная плитка Шашки отлично подходит для отделки крыльца,
                  отмостки, пола в гараже, пешеходных дорожек, площадки под
                  беседку и пр. Стандартный размер Шашки 30Х30Х3 см. В 1 кв
                  метре 11 штук по цене 12 рублей
                </Card.Text>
              </Card.Body>
            </Card>

            <Card className="bg-secondary text-white" border="dark">
              <Card.Img variant="top" src={tile17} />
              <Card.Body>
                <Card.Title>Бордюр поворотный</Card.Title>
                <Card.Text>
                  ⁠Им оформляют клумбы, газоны, площади и пешеходные
                  дорожки.Цена 1 бордюра 3 рубля
                </Card.Text>
              </Card.Body>
            </Card>
          </CardDeck>
        </Container>
      </>
    );
  }
}
